/**
 * Spłaszcza tablicę tablic
 *
 * @export
 * @template T
 * @param {T[][]} array
 * @returns {T[]}
 */
export function flat<T>(array: Array<T | T[]>): T[] {
  return array.reduce((a: T[], b: T | T[]) => {
    if (Array.isArray(b)) {
      a.push(...b);
    } else {
      a.push(b);
    }
    return a;
  }, []);
}
